import { Component} from '@angular/core';

@Component({
    selector: 'letter-setting-main',
    templateUrl: './letter-setting-main.tmpl.html'
})

export class LetterSettingMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  